import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Select, Button, Slider, Switch } from "antd";
import { getSummary } from "../../utils/api";
import "./Phone.css";

function ProgressRing({ day, setDay }) {
  const radius = 18;
  const circumference = ((2 * 22) / 7) * radius;
  const percent = 30 + parseInt(Math.random() * 50);
  const click = () => {
    setDay(day);
  };
  return (
    <>
      <div className="ProgressRing" onClick={click} onTouchEnd={click}>
        <svg className="progress-ring">
          <circle
            className="progress-ring__circle-back"
            fill="transparent"
            r={radius}
            cx={radius + 4}
            cy={radius + 4}
          />
          <circle
            className="progress-ring__circle"
            fill="transparent"
            r={radius}
            cx={radius + 4}
            cy={radius + 4}
            strokeDasharray={(percent * circumference) / 100}
          />
        </svg>
      </div>
    </>
  );
}

export default observer(ProgressRing);
